import { Component } from '@angular/core';
import { AbstractFormComponent } from '@shared/components/abstracts/abstract-form.component';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { PublicService } from '@shared/services/public.service';
import { AuthService } from '@shared/services/auth.service';
import { NgIf } from '@angular/common';
import { ToastService } from '@shared/services/toast.service';
import { StateType } from '@shared/enums/state-type';
import { HttpErrorResponse } from '@angular/common/http';
import { animate, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute } from '@angular/router';
import { ModalChoice } from '@shared/pages/dashboard/dashboard-settings/interfaces/modal-choice';
import { UserService } from '@shared/services/user.service';
import { DocumentData } from '@shared/interfaces/document-data';
import { ModalChoiceComponent } from '@shared/components/modal/modal-choice/modal-choice.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unsubscribe',
  imports: [ReactiveFormsModule, NgIf, ModalChoiceComponent, TranslateModule],
  templateUrl: './unsubscribe.component.html',
  animations: [
    trigger('opacity', [
      transition(':enter', [
        style({
          opacity: 0,
        }),
        animate(
          '150ms',
          style({
            opacity: 1,
          })
        ),
      ]),
      transition(':leave', [
        style({
          opacity: 1,
        }),
        animate(
          '150ms',
          style({
            opacity: 0,
          })
        ),
      ]),
    ]),
    trigger('open', [
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateY(0.25rem)',
        }),
        animate(
          '200ms',
          style({
            opacity: 1,
            transform: 'translateY(0)',
          })
        ),
      ]),
      transition(':leave', [
        style({
          opacity: 1,
          transform: 'translateY(0)',
        }),
        animate(
          '150ms',
          style({
            opacity: 0,
            transform: 'translateY(0.25rem)',
          })
        ),
      ]),
    ]),
  ],
})
export class UnsubscribeComponent extends AbstractFormComponent {
  isUnsubscribeErrorMessage?: string;
  isOpenConfirmModal = false;
  isOpenModalDeleteAccount = false;
  modalDeleteAccount: ModalChoice = {
    action: this.translateService.instant('COMMON.MODAL.UNSUBSCRIBE.ACTION'),
    cancel: this.translateService.instant('COMMON.CANCEL'),
    type: 'DANGER',
    description: this.translateService.instant(
      'COMMON.MODAL.UNSUBSCRIBE.INTRO'
    ),
    title: this.translateService.instant('COMMON.MODAL.UNSUBSCRIBE.TITLE'),
  };

  constructor(
    private publicService: PublicService<DocumentData>,
    private authService: AuthService,
    private toastService: ToastService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private translateService: TranslateService
  ) {
    const form = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/),
      ]),
    });
    super(form);
    this.activatedRoute.queryParams.subscribe(params => {
      const { email } = params;
      if (email) {
        this.formGroup.setValue({ email });
        this.onSubmit();
      }
    });
    this.userService.getUser$().subscribe(user => {
      if (user) {
        const control = this.formGroup.get('email');
        if (control) {
          control.setValue(user.email);
        }
      }
    });
  }

  onCloseModal() {
    // @ts-ignore
    window.location = window.location.href.split('?')[0];
  }

  onValidateDeleteAccount($event: boolean) {
    this.isOpenModalDeleteAccount = false;
    if ($event) {
      const email = this.formGroup.get('email');
      if (email) {
        this.publicService.deleteAccount(email.value as string).subscribe(
          () => {
            this.isOpenConfirmModal = true;
            this.isUnsubscribeErrorMessage = undefined;
            this.authService.logout(false);
          },
          (err: HttpErrorResponse) => {
            if (err.status >= 400 && err.status < 500) {
              this.isUnsubscribeErrorMessage = err.error.error.message;
            } else {
              this.toastService.addToast({
                type: StateType.DANGER,
                title: this.translateService.instant(
                  'COMMON.TOAST.ERROR.TITLE'
                ),
                message: this.translateService.instant(
                  'COMMON.TOAST.ERROR.MESSAGE'
                ),
              });
            }
            this.onDisabled(false);
          }
        );
      }
    } else {
      super.onDisabled(false);
    }
  }

  protected override onSubmit(): boolean {
    this.isOpenModalDeleteAccount = true;
    return true;
  }
}
